import type { Kpis } from "@/lib/dashApi";

export function num(kpis: Kpis | undefined, key: string): number | null {
  const v = kpis?.[key];
  return typeof v === "number" ? v : null;
}

export function str(kpis: Kpis | undefined, key: string): string | null {
  const v = kpis?.[key];
  return typeof v === "string" ? v : null;
}

export function rows<T = Record<string, unknown>>(kpis: Kpis | undefined, key: string): T[] {
  const v = kpis?.[key];
  return Array.isArray(v) ? (v as T[]) : [];
}

export type LabelValue = { label: string; value: number };
export type NameValue = { name: string; value: number; count?: number; orders?: number };
